
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[host]/[slug]",
      function () {
        return require("private-next-pages/[host]/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[host]/[slug]"])
      });
    }
  